<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row class="h-5">
        <b-col cols="12">
          <S040000Menu
            :t="t"
            :dictEnum="dictEnum"
            :isLeaveRecordVisible="
              hasRight('AlwRead', Settings.MenuID.StaffLeaveRecord)
            "
            :isStaffAttendanceVisible="
              hasRight('AlwRead', Settings.MenuID.StaffAttendance)
            "
            :isMonthlyVisible="
              hasRight('AlwRead', Settings.MenuID.MonthlyLeaveBalance)
            "
            :isOutdoorVisible="
              hasRight('AlwRead', Settings.MenuID.OutdoorWorkAllowance)
            "
            :isTaxReturnVisible="hasRight('AlwRead', Settings.MenuID.TaxReturn)"
          />
        </b-col>
      </b-row>

      <b-row class="h-10" align-v="center">
        <b-col cols="2">
          <date-picker
            id="dpMonth"
            :placeholder="this.t.t(dictEnum.LBL_Month)"
            v-model="month"
            :lang="lang"
            type="month"
            format="MM/YYYY"
            v-bind:editable="false"
            v-bind:clearable="false"
            @change="getStaffList()"
          ></date-picker>
        </b-col>
        <b-col cols="2">
          <b-form-select size="sm" v-model="selectedComp" @change="changeComp">
            <option value selected>
              --- {{ this.t.t(dictEnum.LBL_Company) }} ---
            </option>
            <option
              v-for="(comp, index) in compList"
              :key="index"
              :value="comp.CompCode"
            >
              {{ user.Lang == "EN" ? comp.EName : comp.CName }}
            </option>
          </b-form-select>
        </b-col>
        <b-col cols="2">
          <!-- <select v-model="selectedStaff" class="form-control">
            <option value selected>
              --- {{ this.t.t(dictEnum.LBL_Staff) }} ---
            </option>
            <option
              v-for="option in StaffList"
              v-bind:key="option.StaffID"
              v-bind:value="option.StaffID"
            >
              {{
                user.Lang == "EN"
                  ? `${option.EngName} ${option.EngLastName}`
                  : `${option.ChiLastName}${option.ChiName}`
              }}
            </option>
          </select> -->
          <div class="d-flex align-items-center input-mb-0">
            <v-text-field
              :readonly="true"
              style="margin-top: -12px"
              class="form-input"
              name="staff"
              v-validate="{
                required: true
              }"
              :placeholder="'--- ' + this.t.t(dictEnum.LBL_Staff) + ' ---'"
              v-model="selectedStaff"
            ></v-text-field>
            <button
              type="button"
              class="btn btn-transparent p-1"
              :disabled="false"
              v-on:click="OnStaffBtnClick()"
            >
              <img src="../../../static/images/search.png" class="w-14" />
            </button>
          </div>
        </b-col>

        <b-col cols="6" align-self="center" class="text-right">
          <button class="btn btn-info" @click="search">
            {{ this.t.t(dictEnum.LBL_Filter) }}
          </button>

          <download-excel
            v-if="hasRight('AlwExp', Settings.MenuID.OutdoorWorkAllowance)"
            class="btn btn-primary"
            :fetch="ExportTableData"
            :fields="columnsexport"
            type="xls"
            name="outdoorworkallownace.xls"
            :meta="[{ key: 'charset', value: 'utf-8' }]"
            >{{ this.t.t(dictEnum.BTN_Export) }}</download-excel
          >
        </b-col>
      </b-row>

      <b-row class="h-80">
        <b-col cols="12">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table h-85">
              <b-table
                :items="tableData"
                :fields="fields"
                :current-page="currentPage"
                :per-page="15"
              >
                <template #cell(ActIn)="data">
                  <div
                    :class="{
                      'table-lateIn': data.item.ActIn > data.item.ExtIn
                    }"
                  >
                    {{ data.item.ActIn }}
                  </div>
                </template>
                <template #cell(ActOut)="data">
                  <div
                    :class="{
                      'table-lateIn': data.item.ExtOut > data.item.ActOut
                    }"
                  >
                    {{ data.item.ActOut }}
                  </div>
                </template>
                <template #cell(IsFromApp)="data">
                  {{ data.item.IsFromApp ? "Y" : "N" }}
                </template>
              </b-table>
            </div>
            <b-row no-gutters class="pt-3" v-if="tableData.length > 0">
              <b-col cols="2">
                <b-pagination
                  first-number
                  last-number
                  limit="10"
                  v-model="currentPage"
                  :per-page="15"
                  :total-rows="tableData.length"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Staff  Modal Start -->
    <div
      class="modal fade"
      id="staffModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="staffModel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-820" role="document">
        <div class="modal-content list-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ t.t(dictEnum.LBL_StaffList) }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-search">
            <form class="form-inline">
              <div class="form-group mx-sm-3 mb-2 mt-2">
                <label for="inputPassword2" class="sr-only">search</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputPassword2"
                  v-model="searchValue"
                  :placeholder="t.t(dictEnum.LBL_SearchStaff)"
                />
              </div>
            </form>
          </div>
          <div class="modal-body p-0">
            <v-simple-table
              class="table table-sm mb-0 modal-tbl"
              min-height="500"
              height="500"
            >
              <template>
                <thead>
                  <tr>
                    <th width="15%">
                      {{ t.t(dictEnum.LBL_StaffID) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_UserChiname) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_EngName) }}
                    </th>
                    <th width="20%">
                      {{ t.t(dictEnum.LBL_Job) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in StaffList"
                    v-on:click="OnStaffSelect(item)"
                    :key="index"
                  >
                    <td width="15%">{{ item.StaffID }}</td>
                    <td width="20%">
                      {{ `${item.ChiLastName}${item.ChiName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.EngName} ${item.EngLastName}` }}
                    </td>
                    <td width="20%">
                      {{ `${item.JobTitle}` }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </div>
    </div>
    <!-- Staff Modal End -->
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import ReportService from "@/service/ReportService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import S040000Menu from "@/components/S040000-Report/S040000-Menu.vue";
import SweetAlertService from "@/service/SweetAlertService";
import { datePickerLang } from "@/constants/globalConstants";
import Settings from "../../constants/Settings";
import StaffService from "../../service/StaffService";
import ArrayHelper from "../../common/helper/ArrayHelper";

export default {
  components: {
    DatePicker,
    moment,
    S040000Menu
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      Settings: Settings,
      menuId: Settings.MenuID.OutdoorWorkAllowance,
      staffList: [],
      searchValue: "",
      selectedStaff: "",
      selectedUserID: "",
      dictEnum: dictEnum,

      columnsexport: {
        Date: "Date",
        Description: "Description",
        ExtIn: "ExtIn",
        ActIn: "ActIn",
        AddrIn: "AddrIn",
        ExtOut: "ExtOut",
        ActOut: "ActOut",
        AddrOut: "AddrOut",
        WorkHours: "WorkHours",
        Allowance: "Allowance"
      },
      tableData: [],

      month: moment()
        .startOf("month")
        .format(Settings.DateTime.yyyymmdd),
      // custom lang
      lang: datePickerLang,
      currentPage: 1,
      fields: [
        {
          key: "Date",
          label: t.t(dictEnum.LBL_Date)
        },
        {
          key: "Description",
          label: t.t(dictEnum.LBL_Description)
        },
        {
          key: "ExtIn",
          label: t.t(dictEnum.LBL_ExpectedInAbbr)
        },
        {
          key: "ActIn",
          label: t.t(dictEnum.LBL_ActInAbbr)
        },
        {
          key: "AddrIn",
          label: t.t(dictEnum.LBL_AddrIn)
        },
        {
          key: "ExtOut",
          label: t.t(dictEnum.LBL_ExpectedOutAbbr)
        },
        {
          key: "ActOut",
          label: t.t(dictEnum.LBL_ActOutAbbr)
        },
        {
          key: "AddrOut",
          label: t.t(dictEnum.LBL_AddrOut)
        },
        {
          key: "WorkHours",
          label: t.t(dictEnum.LBL_WorkHrs)
        },
        {
          key: "Allowance",
          label: t.t(dictEnum.LBL_Allowance)
        }
      ],
      compList: [],
      selectedComp: ""
    };
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    userName() {
      return this.$store.getters[StoreGetter.user].Lang == "EN"
        ? this.$store.getters[StoreGetter.user].EngName
        : this.$store.getters[StoreGetter.user].ChiName;
    },
    StaffList() {
      let list = this.staffList;
      if (this.selectedComp) {
        list = list.filter(x => x.CompCode == this.selectedComp);
      }
      if (this.searchValue != "") {
        list = list.filter(x =>
          ArrayHelper.staffSearch(x, this.searchValue.toLowerCase())
        );
      }
      return list;
    }
  },
  methods: {
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },

    assignRights() {
      this.menuRights.allRights = this.menuRights.allRights = this.$store.getters[
        StoreGetter.sysMenu
      ];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    changeComp() {
      this.selectedStaff = "";
      this.selectedUserID = "";
    },

    OnStaffBtnClick: function() {
      $("#staffModel").modal("show");
    },
    OnStaffSelect: function(model) {
      var self = this;
      if (self.$store.getters[StoreGetter.user].Lang == "EN") {
        self.selectedStaff = model["EngName"] + " " + model["EngLastName"];
      } else {
        self.selectedStaff = model["ChiLastName"] + model["ChiName"];
      }
      self.selectedUserID = model["StaffID"];
      $("#staffModel").modal("hide");
    },

    async search() {
      if (this.selectedStaff == "") {
        SweetAlertService.error(
          "Error",
          this.t.t(dictEnum.LBL_Staff) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (this.month == "") {
        SweetAlertService.error(
          "Error",
          this.t.t(dictEnum.LBL_Month) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      const obj = {
        userId: this.selectedUserID,
        date: moment(this.month)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd),
        compCode: this.selectedComp
      };

      const response = await ReportService.getStaffOutdoorworkAllowance(obj);
      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.error("Error", response.data.Message);
      }
    },

    async ExportTableData() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        return this.tableData;
      }
    },

    async getCompanyList() {
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffList() {
      const obj = {
        staffID: this.user.UserID,
        dateFrom: moment(this.month)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd),
        dateTo: moment(this.month)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd)
      };
      const response = await StaffService.getStaffListOnDuty(obj);
      if (response.data.IsSuccess) {
        this.staffList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getdatatable() {
      const date = moment(this.month)
        .startOf("month")
        .format(Settings.DateTime.yyyymmdd);
      const obj = {
        userId: this.$store.getters[StoreGetter.user].UserId,
        date: date
      };

      const response = await ReportService.getStaffOutdoorworkAllowance(obj);
      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.error("Error", response.data.Message);
      }
    }
  },
  mounted() {
    this.assignRights();
    //this.getdatatable();
    this.getStaffList();
    this.getCompanyList();
  }
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  min-height: 158px !important;
}
.mx-calendar-icon {
  width: 100%;
  height: auto !important;
  color: #555;
  stroke-width: 8px;
  stroke: currentColor;
  fill: currentColor;
}

.table-lateIn {
  height: 100%;
  background-color: #e6bfd6;
}
.table-leaveEarly {
  height: 100%;
  background-color: #d0eef8;
}
</style>



// WEBPACK FOOTER //
// src/components/S040000-Report/S040400-OutdoorworkAllowance.vue